{
  "general": {
    "title": "Sammenlign alternativer",
    "intro": "En rask titt på forskjellen mellom Community, abonnement og engangskjøp.",
    "tableheader": "Abonnement",
    "note1": "* Gruppekjøpsalternativer og volumrabatt tilgjengelig.",
    "note2": "** Støttede språk: Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Krever en gratis Community-konto på myBoardmaker og er kun beregnet for lagring av aktiviteter."
  },
  "columnHeadings": {
    "community": "COMMUNITY",
    "onetime": "ENGANGSKJØP*",
    "personal": "PERSONLIG ABONNEMENT",
    "professional": "PROFESJONELT ABONNEMENT",
    "organization": "ORGANISASJONSABONNEMENT*"
  },
  "mobileHeadings": {
    "community": "Community",
    "onetime": "Engangskjøp*",
    "personal": "Personlig abonnement",
    "professional": "Profesjonelt abonnement",
    "organization": "Organisasjonsabonnement*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Aktivering",
    "languages": "Språk*",
    "licensing": "Lisensiering",
    "pcsSymbols": "PCS-symboler",
    "templates": "Maler",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Spill av aktiviteter som instruktør",
    "playActivitiesStudent": "Spill av aktiviteter som student",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Instruktørledelse",
    "studentManagement": "Studentledelse",
    "assignStudentActivities": "Tilordne studentaktiviteter",
    "cloudStorage": "Skylagring",
    "createAndJoin": "Opprett og bli med i grupper",
    "accessCommunity": "Tilgang til over 120 000 Community-aktiviteter",
    "shareActivity": "Del aktiviteter i Community",
    "curriculum": "Pensum og innhold",
    "activitiesToGo": "Boardmaker Activities to Go",
    "instructionalSolutions": "Instructional Solutions",
    "premiumActivities": "Premium-aktiviteter",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 enheter",
    "unlimited": "Ubegrenset",
    "byKey": "Lisensnøkkel",
    "symbols": "Over 80 000",
    "templates": "Over 600",
    "languages": "12",
    "login": "Innlogging",
    "yes": "Ja",
    "yesNote": "Ja***",
    "no": "Nei"
  }
}